export enum Events {
  NodePointerDown = 'NodePointerDown',
  NodePointerUp = 'NodePointerUp',
  NodePointerMove = 'NodePointerMove',
}
